"use client";
import { FadeUp, StaggerContainer, StaggerItem } from "@/components/ui/section";
import Image from "next/image";
import { useTranslations } from "next-intl";

export default function Reviews({ reviews }) {
  const t = useTranslations("home");
  return (
    <section className="py-24 lg:py-32 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeUp className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-white">{t("reviewsHeading")}</h2>
        </FadeUp>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {reviews.map((review, i) => (
            <StaggerItem key={i}>
              <div className="h-full rounded-2xl bg-white border border-zinc-200 shadow-sm hover:border-violet-400/50 hover:shadow-md dark:bg-zinc-900 dark:border-white/[0.08] dark:shadow-none dark:hover:border-violet-500/20 p-7 flex flex-col gap-5 transition-colors">
                <div className="text-5xl font-serif leading-none bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">
                  &ldquo;
                </div>

                <p className="text-sm text-zinc-400 leading-relaxed flex-1">
                  {review.message}
                </p>

                <div className="flex items-center gap-3 pt-4 border-t border-zinc-200 dark:border-white/[0.06]">
                  {review.logo ? (
                    <Image
                      src={review.logo}
                      alt={review.name}
                      width={40}
                      height={40}
                      className="w-10 h-10 rounded-full object-cover ring-2 ring-violet-500/20"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-violet-500/20 to-cyan-500/20 border border-violet-500/20 flex items-center justify-center text-xs font-bold text-violet-300 flex-shrink-0">
                      {review.initials ?? review.name.slice(0, 2).toUpperCase()}
                    </div>
                  )}
                  <div>
                    <p className="text-sm font-medium text-white">{review.name}</p>
                    {review.position && (
                      <p className="text-xs text-zinc-500">{review.position}</p>
                    )}
                  </div>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}
